import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL, HTTP_STATUS } from '../../utils/constant'
import { newAxiosInstance } from '../../../axios'

const initialState = {
    currentPeriod: null,   // { year, month }
    status:        HTTP_STATUS.IDLE,
    closeStatus:   HTTP_STATUS.IDLE,
}

export const fetchPayrollPeriod = createAsyncThunk('payrollPeriod/fetch', async (_, { rejectWithValue }) => {
    try {
        const res = await newAxiosInstance.get(BASE_URL + '/api/PayrollPeriod/current')
        return res.data
    } catch(err) {
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const closePayrollPeriod = createAsyncThunk('payrollPeriod/close', async (body, { rejectWithValue }) => {
    try {
        const res = await newAxiosInstance.post(BASE_URL + '/api/PayrollPeriod/close-month', body)
        return res.data
    } catch(err) {
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

const PayrollPeriod = createSlice({
    name: 'payrollPeriod',
    initialState,
    reducers: {
        resetState: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(fetchPayrollPeriod.pending, (state) => {
                state.status = HTTP_STATUS.LOADING
            })
            .addCase(fetchPayrollPeriod.fulfilled, (state, action) => {
                state.status = HTTP_STATUS.SUCCEEDED
                state.currentPeriod = action.payload
            })
            .addCase(fetchPayrollPeriod.rejected, (state) => {
                state.status = HTTP_STATUS.FAILED
            })
            .addCase(closePayrollPeriod.pending, (state) => {
                state.closeStatus = HTTP_STATUS.LOADING
            })
            .addCase(closePayrollPeriod.fulfilled, (state, action) => {
                state.closeStatus = HTTP_STATUS.SUCCEEDED
                state.currentPeriod = action.payload
            })
            .addCase(closePayrollPeriod.rejected, (state) => {
                state.closeStatus = HTTP_STATUS.FAILED
            })
    }
})

export const getPayrollCurrentPeriod     = (state) => state.payrollPeriod.currentPeriod;
export const getPayrollPeriodStatus      = (state) => state.payrollPeriod.status;
export const getPayrollPeriodCloseStatus = (state) => state.payrollPeriod.closeStatus;
export const payrollPeriodActions        = PayrollPeriod.actions;

export default PayrollPeriod.reducer;
